import CheckoutCartPendingPurchases from './CheckoutCartPendingPurchases';

export default CheckoutCartPendingPurchases;
